
import React from 'react';
import { useSelector } from 'react-redux';

// libs
import { Route, Switch, Redirect } from 'react-router-dom';

// routePages
import AuthPage, {routeAuth as routeAuthPage} from 'pages/AuthPage';
import AdminPage, {routeAdmin as routeAdminPage} from 'pages/AdminPage';
import PromoPage, {routePromo as routePromoPage} from 'pages/PromoPage';
import LogsPage, {routeLogs as routeLogsPage} from 'pages/LogsPage';
import GamesPage, {routeGames as routeGamesPage} from 'pages/GamesPage';
import MailingPage, {routeMailing as routeMailingPage} from 'pages/MailingPage';
import AdminUsersPage, {routeAdminUsers as routeAdminUsersPage} from 'pages/AdminUsersPage';
import JackpotPage, {routeJackpot as routeJackpotPage} from 'pages/JackpotPage';
import PageWrapper from "../PageWrapper";

const AppContent = () => {
    const role = useSelector((state) => state?.profileData?.role);
    const isSuperAdmin = Number(role) === 1;

    const innerPageWrapper = (component) => (
        <PageWrapper>
            {component}
        </PageWrapper>
    );

    // Redirects manager to /admin before the page mounts and makes any API calls
    const superAdminRoute = (path, component) => (
        <Route
            exact
            path={path}
            render={() =>
                isSuperAdmin
                    ? innerPageWrapper(component)
                    : <Redirect to={routeAdminPage()} />
            }
        />
    );

    return (
        <div className="main-wrapper">
            <main className='main-container'>
                <Switch>
                    <Route exact path={routeAuthPage()} component={AuthPage} />
                    <Route exact path={routeAdminPage()} render={() => innerPageWrapper(<AdminPage/>)} />
                    <Route exact path={routeJackpotPage()} render={() => innerPageWrapper(<JackpotPage/>)} />

                    {superAdminRoute(routePromoPage(), <PromoPage/>)}
                    {superAdminRoute(routeLogsPage(), <LogsPage/>)}
                    {superAdminRoute(routeGamesPage(), <GamesPage/>)}
                    {superAdminRoute(routeMailingPage(), <MailingPage/>)}
                    {superAdminRoute(routeAdminUsersPage(), <AdminUsersPage/>)}

                    <Redirect to={{ pathname: routeAdminPage() }} />
                </Switch>
            </main>
        </div>
    );
}

export default AppContent;